// jscpd:ignore-start
import { HttpErrorResponse } from '@angular/common/http'
import moment from 'moment'
import { NGXLogger } from 'ngx-logger'
import { Observable } from 'rxjs'
import { BlockerService } from 'src/app/modules/account/services/blocker.service'
import { GlobalErrorHandler } from 'src/app/GlobalErrorHandler'
import { LoanInfo, OfferInfo, PayOfferObject } from 'src/app/core/helpers/interfaces'
import {
  jsonDeclinedCoboOffer,
  jsonDeclinedCoboOfferCreditFreeze,
  jsonFullyApproved2Options,
  jsonPartiallyApproved,
  jsonWelcomeBackScreen,
} from 'src/app/core/helpers/loanInfoUtils'
import { ApiService } from 'src/app/core/services/api.service'
import { LoanOptionsService } from 'src/app/core/services/loan-options.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { SendAppLinkService } from 'src/app/core/services/send-app-link.service'
import { UserStateType } from 'src/app/core/services/user-state.service'
import { ModalOptionsNavigation } from './modal-navigation'
import { OptionsStore } from './options-store'
import { isPlatformBrowser } from '@angular/common'
import { Inject, PLATFORM_ID } from '@angular/core'
// jscpd:ignore-end
export class RequestHandler {
  store: OptionsStore
  navigation: ModalOptionsNavigation
  api: ApiService
  pageNavigationService: PageNavigationService
  modalStateService: ModalStateService
  loanOptionsService: LoanOptionsService
  sendAppLinkService: SendAppLinkService
  breakpoints: any
  logger: NGXLogger
  errHandler: GlobalErrorHandler

  constructor(
    store: OptionsStore,
    navigation: ModalOptionsNavigation,
    api: ApiService,
    pageNavigationService: PageNavigationService,
    modalStateService: ModalStateService,
    loanOptionsService: LoanOptionsService,
    sendAppLinkService: SendAppLinkService,
    // notifier: NotifierService,
    errHandler: GlobalErrorHandler,
    breakpoints: any,
    logger: NGXLogger,
    private _blocker: BlockerService,
       // @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.store = store
    this.navigation = navigation
    this.api = api
    this.pageNavigationService = pageNavigationService
    this.modalStateService = modalStateService
    this.loanOptionsService = loanOptionsService
    this.sendAppLinkService = sendAppLinkService
    // this.notifier = notifier
    this.errHandler = errHandler
    this.breakpoints = breakpoints
    this.logger = logger
  }

  /**
   * show credit freeze
   * @param res loanData for credit freeze
   */
  public showCreditLockClick(res?): void {
    if (res) {
      this.store.loanData = res
    }
    this.store.loading = false
    this.store.showDentistSelect = false
    this.store.showMainBlock = false
    this.store.showCreditLock = true
  }

  /**
   *  check is next step credit freeze and show it
   * @returns true if credit freeze
   */
  parseNextStep(res): boolean {
    if (!res) {
      console.warn('no res in parseNextStep')
      return false
    }
    if (res.nextStep === 'Pre_LO_Credit_Freeze') {
      this.showCreditLockClick(res)
      return true
    }
    return false
  }

  /**
   * DEV only method, setting dev status by selection
   * @param resData not used
   * @returns new response data with substatus
   */
  setDevStatus(resData): any {
  /*   if (!isPlatformBrowser(this.platformId)) {
      return;
    } */

    if ((typeof document === "undefined") || (typeof document === undefined)){
      return;
    } 
    const devStatus: any = document.getElementById('devSubStatus')
    let newResData: any = {}
     if (devStatus) {
   
      this.logger.info(devStatus)
      if (devStatus.value !== '') {
        this.logger.info('ACTIVATED DEV STATUS')
        this.logger.info(devStatus.value)
        if (devStatus.value.trim() === 'PARTIALLY_APPROVED') {
          const obj = JSON.parse(jsonPartiallyApproved)
          newResData = obj.data
          this.logger.info(newResData)
        }
        if (devStatus.value.trim() === 'DECLINED_WITH_COBO_OFFER') {
          const obj = JSON.parse(jsonDeclinedCoboOffer)
          newResData = obj.data
          this.logger.info(newResData)
        }
        if (devStatus.value.trim() === 'FULLY_APPROVED') {
          const obj = JSON.parse(jsonFullyApproved2Options)
          newResData = obj.data
          newResData.subStatus = devStatus.value
          this.logger.info(newResData)
        }
        if (devStatus.value.trim() === 'CREDIT_FREEZE') {
          const obj = JSON.parse(jsonDeclinedCoboOfferCreditFreeze)
          newResData = obj.data
          // newResData.subStatus = devStatus.value
          this.logger.info(newResData)
        }
        if (devStatus.value.trim() === 'WELCOME_BACK_SCREEN') {
          const obj = JSON.parse(jsonWelcomeBackScreen)
          newResData = obj.data
          newResData.subStatus = 'WELCOME_BACK_SCREEN'
          this.store.showWelcomeBack = true
          // newResData.subStatus = devStatus.value
          this.logger.info(newResData)
        }
        if (devStatus.value.trim() === 'WELCOME_BACK_SCREEN') {
          const obj = JSON.parse(jsonWelcomeBackScreen)
          newResData = obj.data
          newResData.subStatus = 'WELCOME_BACK_SCREEN'
          this.store.showWelcomeBack = true
          // newResData.subStatus = devStatus.value
          this.logger.info(newResData)
        } else {
          newResData.subStatus = devStatus.value
        }
        return newResData
      }
    }
    return resData
  }

  /**
   * check and process welcome back logic
   * @param res - actual response
   * @returns true if welcome back was accepted
   */
  checkWelcomeBackExistingUser(res): boolean {
    // Returning website visitor (within 30 days of receiving loan offer)
    // who has NOT registered an iCreditWorks account
    // console.log(this.store.loanInfo.amount, this.store.approvedLoanAmount)
    // this.store.showWelcomeBack = true
    //   this.store.showWelcomeBackContinue = true
      // this.store.showWelcomeBack = true
      // this.store.showWelcomeBackContinue = true
      // return true
    let lastActiveDate = res.lastActiveSessionDate
    this.store.lastSessionDate = lastActiveDate
    this.store.nextStep = res.nextStep
    if (res.nextStep === 'Pre_LO_Max_Approved' || res.nextStep === 'Pre_LO_FA') {
      this.store.showWelcomeBack = true
      this.store.showWelcomeBackContinue = true
      // this.store.lastSessionDate = lastActiveDate
      this.store.showDentistSelect = false
      this.store.loanId = res.loanId
      this.store.userId = res.userId
      // check options
      // do not make transuinion check
      // show modal options
      // this.api.getLoanOptions(res.userId, res.loanId).subscribe((r) => {
      //   const data = r.data
      //   // this.store.offersInfo = r
      //   this.store.loanData = r.data
      //   this.store.loanAcctId = res.loanAcctId
      //   this.store.approvedLoanAmount = res.approvedLoanAmount
      //   this.store.maxApprovedLoanAmount = res.maxApprovedLoanAmount
      //   this.store.loanId = res.loanId
      //   this.store.offersInfo = this.mapLoanOptions(data.options, data.noAutoPayLoanOptions) as any
      //   this.navigation.setShowSelectBlock()
      // })
      return true
    }
    if (res.nextStep === 'Pre_LO_PA_Decision') {
      this.store.loanId = res.loanId
      this.store.userId = res.userId
      this.store.showWelcomeBack = true
      this.store.showWelcomeBackContinue = true
      this.store.showDentistSelect = false
      // this.store.loanInfo.amount = res.requestedAmount
      // this.store.approvedLoanAmount = res.approvedLoanAmount
      // this.store.isPartialApproved = true
      // this.navigation.setShowPartialApproved()
      // this.store.showDentistSelect = false
      return true
    }
    if (res.nextStep === 'Post_LA_Login' || res.nextStep === 'User_Registration') {
      this.store.showWelcomeBack = true
      this.store.showDentistSelect = false
      return true
    }
    if (res.nextStep === 'Pre_LO_None') {
      this.store.showWelcomeBack = true
      this.store.showWelcomeBackContinue = true
      this.store.loanData = res
      this.store.showDentistSelect = false
      // this.navigation.setShowDecline()
      // this.store.showDentistSelect = false
      return true
    }
    if (res.nextStep === 'Post_LA_Pend_Coffee_Cup') {
      this.store.showWelcomeBack = true
      this.store.showWelcomeBackContinue = true
      this.store.showDentistSelect = false
      // this.navigation.setShowException()
      // this.store.showDentistSelect = false
      // this.showCreditLockClick(res)
      // this.store.showWelcomeBack = true
      // this.store.showWelcomeBackContinue = true
      // this.store.lastSessionDate = lastActiveDate
      // this.store.showDentistSelect = false
      // this.store.loanId = res.loanId
      // this.store.userId = res.userId
      return true
    }
    if (res.nextStep === 'Pre_LO_Credit_Freeze') {
      this.store.showWelcomeBack = true
      this.store.showWelcomeBackContinue = true
      this.store.showDentistSelect = false
      this.store.loanData = res
      // this.showCreditLockClick(res)
      // this.store.showDentistSelect = false
      this.store.creditData = res
      // this.showCreditLockClick(res)
      // this.store.showWelcomeBack = true
      // this.store.showWelcomeBackContinue = true
      // this.store.lastSessionDate = lastActiveDate
      // this.store.showDentistSelect = false
      // this.store.loanId = res.loanId
      // this.store.userId = res.userId
      return true
    }
    

    // Returning website visitor (within 30 days of receiving loan offer)
    // who has YES registered an iCreditWorks account
    // if (res.nextStep === 'Post_LA_Login' || res.nextStep === 'User_Registration')

    // else  {

      // show welcome back
      this.store.showWelcomeBack = true
      // this.store.showMainBlock = true
      this.store.showDentistSelect = false
      // do not make transuinion check
      return true
    // }

    // return false
  }

  /**
   * parse resData and set next screens
   * @param resData - actual response
   * @returns modified / original response
   */
  sendLoanRequest(resData: any) {
    // dev proposes
    resData = this.setDevStatus(resData)
    this.logger.info(resData)
    if (this.parseNextStep(resData)) {
      return resData
    }
    if (resData.subStatus === 'WELCOME_BACK_SCREEN') {
      return resData
    }
    // if (this.checkWelcomeBack(resData)) {
    //   return resData
    // }
    // console.log('aaa')
    this.store.loanAcctId = resData.loanAcctId
    this.store.approvedLoanAmount = resData.approvedLoanAmount
    this.store.maxApprovedLoanAmount = resData.maxApprovedLoanAmount
    this.store.loanId = resData.loanId
    this.store.offersInfo = resData
    this.store.lastResponse = resData
    this.navigation.setOffAnyState()
    this.logger.info(`current subStatus is : '${resData.subStatus}'`)
    const selectBlockStatuses = ['FULLY_APPROVED', 'PRE-APPROVED', 'PRE-APPROVED_MULTI']
    const partiallyApprovedStatuses = ['PARTIALLY_APPROVED']
    // let dentistSelectStatuses 
    // const showDeclinedAddCoappStatuses = ['DECLINED_WITH_COBO_OFFER']
    const showDeclineStatuses = [
      'PRE_BUREAU_FAILED',
      'DECLINED_MULTI',
      'NO_COBORROWER_OFFERED',
      'DECLINED_ID_VERIF_FAILED',
      'DECLINED_WITH_COBO_OFFER',
    ]
    const showPendingStatuses = ['PENDING_MULTI', 'PENDING_VO_IDENTITY']
    // this.navigation.setShowSelectBlock()
    // return
    if (resData.nextStep === 'Post_Dentist_Search' || resData.nextStep === 'Post_Select_Office_Dentist') {
      this.navigation.setShowSelectDentistBlock()
      return
    }
    if (selectBlockStatuses.includes(resData.subStatus)) {
      // here set multiple offers
      // this.store.offersInfo = this.mapLoanOptions(resData.options, resData.noAutoPayLoanOptions) as any
      this.navigation.setShowSelectBlock()
    } else if (partiallyApprovedStatuses.includes(resData.subStatus)) {
      this.store.isPartialApproved = true
      // this.store.offersInfo = this.mapLoanOptions(resData.options, resData.noAutoPayLoanOptions) as any
      this.navigation.setShowPartialApproved()
    }
    // else if (showDeclinedAddCoappStatuses.includes(resData.subStatus)) {
    //   this.navigation.setShowDeclinedAddCoapplicant()
    // }
    else if (showDeclineStatuses.includes(resData.subStatus)) {
      this.navigation.setShowDecline()
    } else if (resData.nextStep === 'Pre_LO_None_Decision') {
      this.navigation.setShowDecline()
    } else if (showPendingStatuses.includes(resData.subStatus)) {
      this.navigation.setShowException()
    } else if (resData.status === 'DECLINED') {
      this.navigation.setShowDecline()
    } else if (resData.status === 'PENDING') {
      if(resData.subStatus === "PENDING_CREDIT_BUREAU_DOWN"){
        this.navigation.setPartnerDown()
        return
      }
      this.navigation.setShowException()
    } else {
      this.navigation.setShowException()
    }
    // this.store.loading = false
    return resData
  }

  /**
   * process loanOptionSelection request
   * (prepare payload)
   * @param e - OfferInfo, payload
   * @returns API response observable
   */
  loanOptionSelection(e: OfferInfo): Observable<any> {
    let loanResponse = null
    if (this.loanOptionsService?.latestType === 'user') {
      loanResponse = this.loanOptionsService.loanResponse
    }
    if (this.loanOptionsService?.latestType === 'coapp') {
      loanResponse = this.loanOptionsService.coappLoanResponse
    }
    const payObject: PayOfferObject = e.noAutoPayState ? e.noAutoPay : e.autoPay
    this.logger.info(e)
    this.logger.info(loanResponse)
    // console.log(loanResponse)
    const body = {
      userId: loanResponse.userId,
      loanId: loanResponse.loanId,
      loanOptionId: payObject.optionId,
      approvedAmount: payObject.approvedAmount,
      apr: payObject.apr,
      months: payObject.months,
    }
    this.logger.info(body)
    return this.api.loanOptionSelection(body)
  }

  /**
   * transform loanInfo atributes to correct form
   * @param o - LoanInfo object
   * @returns transformed LoanInfo object
   */
  transformLoanInfo(o: LoanInfo): LoanInfo {
    // make a copy
    const newLoan: LoanInfo = Object.assign({}, o)
    const MDY_FORMAT = 'MM/DD/YYYY'
    newLoan.dateOfBirth = moment(newLoan.dateOfBirth).format(MDY_FORMAT)

    if (newLoan.ssn) {
      newLoan.ssn = o.ssn.toString().split('-').join('')
    }

    if (typeof o.amount === 'string') {
      if (o.amount[0] === '$') {
        newLoan.amount = o.amount.slice(1)
        // replace all
        newLoan.amount = newLoan.amount.replace(/,/g, '')
      }
      if (parseInt(o.amount, 10)) {
        newLoan.amount = +o.amount
      }
    }
    if (typeof o.annualIncome === 'string') {
      if (o.annualIncome[0] === '$') {
        newLoan.annualIncome = o.annualIncome.slice(1)
        newLoan.annualIncome = (newLoan.annualIncome as any).replace(/,/g, '')
      }
      if (parseInt(o.annualIncome, 10)) {
        newLoan.annualIncome = +o.annualIncome
      }
    }
    return newLoan
  }

  /**
   * process loan quote request
   * @param o - LoanInfo object
   * @param isCoapp - we should save mobile number
   * @returns API response observable
   */
  getLoanQuote(o: LoanInfo, isCoapp: boolean): Observable<any> {
    const info = this.transformLoanInfo(o)
    if (!isCoapp) {
      // Saving only origin mobile number
      this.store.mobile = info.mobile
    }
    // this.store.mobile = info.mobile
    return this.api.loanQuote(info)

    // const body = JSON.parse(requestFullyApproved)
    // return this.api.loanQuote(body)
  }

  /*
  {"timestamp":1613474905361,"data":null,
  "errors":
  [{"code":"IC-1003","message":"Invalid Date of birth"},
  {"code":"IC-1004","message":"Invalid SSN"}
  ]}
  "errors":[{"code":"IC-1008","message":"Existing user"}]}
  */
  /*
  {"timestamp":1613819032612,"data":{
       "loanId":18833,"userId":20748,"status":"DECLINED","subStatus":"PRE_BUREAU_FAILED",
       "multiSubStatus":null,"approvedLoanAmount":0.0,"originationFee":0.0,
       "autoPayDiscount":0.0,"originationAmount":0.0,"options":null,"noAutoPayLoanOptions":null,
       "creditLockBureaus":null,"nextStep":"Pre_LO_None","loanAcctId":null,"dsoLoanDecision":null,
       "lastActiveSessionDate":"02/20/2021","channelId":null,"raiseAlertForDpOverride":false
     },
     "errors":[{"code":"IC-1008","message":"Existing user"}]}
  */

  parseErrorTypes(errors: any[]) {
    const errorBools = {
      isDob: false,
      isSSN: false,
      isAddress: false,
      existingUser: false,
      isMobile: false,
      isBlockedById: false,
      hasMultiLoans: false
    }
    // if (localStorage.getItem('blocker')) {
    //   let oldBlockerData = JSON.parse(localStorage.getItem('blocker'))
    //   if (oldBlockerData.blockedFor && !moment(moment.now()).isAfter(oldBlockerData.blockedFor)) {
    //     errorBools.isBlockedById = true
    //     return errorBools
    //   }
    // }

    for (const err of errors) {
      switch (err.code) {
        case 'ADDRESS_INVALID':
          errorBools.isAddress = true
          break
        case 'IC-1003':
          errorBools.isDob = true
          break
        case 'IC-1004':
          errorBools.isSSN = true
          break
        case 'IC-1008':
          errorBools.existingUser = true
          break
        case 'IC-1097':
          errorBools.hasMultiLoans = true
          break 
        case 'IC-1041':
          errorBools.isBlockedById = true
          break
        // TODO: response for mobile will be delivered
        // case 'IC-1008':
        //   errorBools.isMobile = true
        //   break
        default:
          break
      }
    }
    return errorBools
  }

  updateMobileCounter(that): number {
    const c = that.userStateService.mobileCounter
    if (c > 3) {
      that.userStateService.mobileCounter = 1
      return that.userStateService.mobileCounter
    }
    that.userStateService.mobileCounter++
    return that.userStateService.mobileCounter
  }

  selectMessageType(
    that,
    errorBools: {
      isDob: boolean
      isSSN: boolean
      isAddress: boolean
      existingUser: boolean
      isMobile: boolean
      isBlockedById: boolean
    }
  ): UserStateType {
    // TODO: send error to logger
    const n = { notify: (a, b) => {} }

    let errorMessageType: UserStateType = null

    if (errorBools.isSSN && errorBools.isDob) {
      errorMessageType = UserStateType.ssn_dob
      this.errHandler.handleError(new Error('Error: Invalid SSN and Date of birth, try again.'))
    } else if (errorBools.isDob) {
      errorMessageType = UserStateType.dob
      this.errHandler.handleError(new Error('Error: Invalid Date of birth, try again.'))
    } else if (errorBools.isSSN) {
      errorMessageType = UserStateType.ssn
      this.errHandler.handleError(new Error('Error: Invalid SSN, try again.'))
    } else if (errorBools.isAddress) {
      errorMessageType = UserStateType.address
      this.errHandler.handleError(new Error('Error: invalid address, try again.'))
    } else if (errorBools.isMobile) {
      this.updateMobileCounter(that)
      errorMessageType = UserStateType.mobile
      this.errHandler.handleError(new Error('Error: Invalid mobile, try again.'))
    } else if (errorBools.isBlockedById) {
      errorMessageType = UserStateType.isBlockedById
      this.errHandler.handleError(new Error('Error: invalid address, try again.'))
    }
    return errorMessageType
  }

  /**
   * error handler for 400 code
   */
  async handle400(errResponse, that): Promise<void> {
    this.logger.info(errResponse.error)
    if (errResponse?.error?.errors) {
      const { errors } = errResponse?.error
      this.logger.info(errors)

      const errorBools = this.parseErrorTypes(errors)

      if (errorBools.hasMultiLoans) {
        // "code":"IC-1097"
        this.store.showWelcomeBack = true
        this.store.showMultiLoan = true
        return
      }

      // Existing user
      if (errorBools.existingUser) {
        // "code":"IC-1008","message":"Existing user"
        const data = errResponse?.error?.data
        if (this.checkWelcomeBackExistingUser(data)) {
          return
        }
      }

      const errorMessageType = this.selectMessageType(that, errorBools)
      if (errorMessageType) {
        this.setInvalidPartsCauseAPIErrors(that, errorMessageType)
        return
      }
      // this._blocker.blockerUpdate()
      that.showErrorScreen()
      that.toggleLoader(false)
    }
  }

  private setInvalidPartsCauseAPIErrors(that, type) {
    // TODO: show different screen
    that.logger.warn(`set type: ${type}`)
    that.toggleLoader(false)
    that.userStateService.isInvalidState = true
    setTimeout(()=>{
      that.userStateService.isInvalidState = false
    },5000)
    that.userStateService.type = type
    // TODO: send to form message to set invalid address
    that.mainForm.notifyFormSetInvalidPartsCauseAPIErrors()
    that.cdr.detectChanges()
  }

  /**
   * global error handler
   */
  async errorHandler(errResponse, that) {
    this.errHandler.handleError(errResponse)
    that.toggleLoader(false)
    // TODO: make if need logger request here
    if (errResponse.status === 400) {
      this.handle400(errResponse, that)
    } else {
      that.showErrorScreen()
      // this._blocker.blockerUpdate()
      // that.notifier.notify('error', JSON.stringify(errResponse))
    }
    that.toggleLoader(false)
  }

  /**
   * helper func: mapping loan options
   * @param options - input options
   * @param noAutoPayOptions - another input options
   * @returns concatenation of options
   */
  mapLoanOptions(options: any[], noAutoPayOptions: any[]) {
    function mapNoAutoPay(value) {
      return noAutoPayOptions.find((val) => val.autoPayMappingOptionId === value.optionId)
    }

    const concatOptionsArr: OfferInfo[] = []
    if (options) {
      options.forEach((option) => {
        concatOptionsArr.push({ noAutoPay: mapNoAutoPay(option), autoPay: option, noAutoPayState: false })
      })
    }

    return concatOptionsArr
  }

  /**
   * collect latestType and if coapp case coappMobileNumber
   * @param obj - contains LoanInfo and coapp: boolean
   */
  collectLoanRequestInfo(obj: { info: LoanInfo; coapp: boolean }): void {
    if (obj.coapp) {
      this.loanOptionsService.latestType = 'coapp'
      this.loanOptionsService.coappMobileNumber = obj.info.mobile
    } else {
      this.loanOptionsService.latestType = 'user'
    }
  }

  /**
   * colleact response info, latestType
   * @param obj - contains LoanInfo and coapp: boolean
   * @param resp - response object
   */
  collectLoanResponseInfo(obj: { info: LoanInfo; coapp: boolean }, resp: any): void {
    if (obj.coapp) {
      this.loanOptionsService.latestType = 'coapp'
      this.loanOptionsService.coappMobileNumber = obj.info.mobile
      this.loanOptionsService.coappLoanAcctId = resp.data.loanAcctId
      this.loanOptionsService.coappLoanResponse = resp.data
    } else {
      this.loanOptionsService.latestType = 'user'
      this.loanOptionsService.loanAcctId = resp.data.loanAcctId
      this.loanOptionsService.loanResponse = resp.data
      if (this.loanOptionsService.coappLoanResponse) {
        this.loanOptionsService.coappLoanResponse = null
        this.loanOptionsService.coappLoanAcctId = null
        this.loanOptionsService.coappMobileNumber = null
      }
    }
    this.logger.info(this.loanOptionsService)
  }
}
